import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';
import FieldService from './Fields';
const path = '/api/private/company_branches';

/**
 * 支店情報一覧取得
 * @param param {object}
 */
const companyBranchList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/list'),
    params: param,
  });
};

/**
 * 協力会社情報取得
 * @param param {object}
 * @param isQuiet {boolean} true = spinnerを利用しない
 */
const companyPartnerList = (param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/company_partner_list'),
    params: param,
    isQuiet,
  });
};

/**
 * 協力会社詳細
 * @param id {int}
 * @param param {object}
 * @param isQuiet {boolean} true = spinnerを利用しない
 */
const show = (id, param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/company_partner/${id}`),
    params: param,
    isQuiet,
  });
};

/**
 * 支社に紐づいている協力会社ユーザー一覧を取得
 * @param id {int}
 * @param param {object}
 * @param isQuiet {boolean} true = spinnerを利用しない
 */
const companyPartnerUserList = (id, param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}/company_partner_user_list`),
    params: param,
    isQuiet,
  });
};

/**
 * 協力会社ユーザー詳細情報を取得
 * @param id {int}
 * @param param {object}
 */
const companyPartnerUser = (id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/company_partner_user/${id}`),
    params: param,
  });
};

/**
 * 協力会社管理者招待(協力会社ユーザー確認画面)
 * @param param {object}
 */
const partnerUser = param => {
  return requestWithToken({
    method: 'POST',
    url: path.concat('/partner_user'),
    data: param,
  });
};

/**
 * 元請一覧
 * @param param {object}
 */
const primeList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/prime_list'),
    params: param,
  });
};

/**
 * 協力会社ユーザー情報更新
 * @param id {int}
 * @param param {object}
 */
const updateCompanyPartnerUser = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/company_partner_user_update/${id}`),
    data: createFormData(param),
  });
};

/**
 * 支店詳細
 * @param id {int}
 */
const showBranch = id => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${id}`),
  });
};

/**
 * 支店更新
 * @param id {int}
 * @param param {object}
 */
const updateBranch = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${id}`),
    data: param,
  });
};

const companyItemOrders = fieldId => {
  // companyItemOrdersを呼ぶ際のcurrentPrimeContractorsCompanyBranchIdの第2引数(mainContractorFlag)は
  // ユーザにかかわらず必ずtrue
  return FieldService.currentPrimeContractorsCompanyBranchId(fieldId, true)
    .then(response => {
      if (!response || !_.has(response, 'data.entities')) {
        // 404や401などでfalse
        throw new Error();
      }
      const companyBranchId =
        response.data.entities.field
          .current_prime_contractors_company_branch_id;
      return companyBranchId;
    })
    .then(companyBranchId =>
      requestWithToken({
        method: 'GET',
        url: path.concat(`/${companyBranchId}/company_item_orders/list`),
      })
    )
    .catch(() => {
      // companyBranchIdの取得失敗時は静的エラーページに飛ばす
      window.location.replace('/error-500');
    });
};

const companyItemSettings = fieldId => {
  // companyItemSettingsを呼ぶ際のcurrentPrimeContractorsCompanyBranchIdの第2引数(mainContractorFlag)は
  // ユーザにかかわらず必ずtrue
  return FieldService.currentPrimeContractorsCompanyBranchId(fieldId, true)
    .then(response => {
      if (!response || !_.has(response, 'data.entities')) {
        // 404や401などでfalse
        throw new Error();
      }
      const companyBranchId =
        response.data.entities.field
          .current_prime_contractors_company_branch_id;
      return companyBranchId;
    })
    .then(companyBranchId =>
      requestWithToken({
        method: 'GET',
        url: path.concat(`/${companyBranchId}/company_item_settings/list`),
      })
    )
    .catch(() => {
      // companyBranchIdの取得失敗時は静的エラーページに飛ばす
      window.location.replace('/error-500');
    });
};

const listForOutputCsv = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/list_for_output_csv`),
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

/**
 * データパラメータ生成
 * @param param {object}
 * @return fd {object}
 */
function createFormData(param) {
  var fd = new FormData();
  _.each(param, (value, index) => {
    if (value && value.type == 'file') {
      fd.append('user_image', value.files[0]);
    } else {
      if (Object.prototype.toString.call(value) === '[object Object]') {
        // eslint-disable-next-line no-unused-vars
        let obj = {};
        _.each(value, (val, col) => {
          fd.append(`${index}[${col}]`, val == undefined ? '' : val);
        });
      } else {
        fd.append(index, value == undefined ? '' : value);
      }
    }
  });

  return fd;
}

const workColumnsSettings = (branchId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${branchId}/work_columns_settings`,
    params: param,
    isQuiet: true,
  });
};

const updateWorkColumnsSettings = (branchId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${branchId}/work_columns_settings`,
    data,
  });
};

const createPartnerUserIntegrate = data => {
  return requestWithToken({
    method: 'POST',
    url: `${path}/partner_user_integrate`,
    data,
  });
};

export const CompanyBranchService = {
  companyBranchList,
  companyPartnerList,
  show,
  companyPartnerUserList,
  companyPartnerUser,
  partnerUser,
  primeList,
  updateCompanyPartnerUser,
  showBranch,
  updateBranch,
  companyItemOrders,
  companyItemSettings,
  listForOutputCsv,
  workColumnsSettings,
  updateWorkColumnsSettings,
  createPartnerUserIntegrate,
};
export default CompanyBranchService;



// WEBPACK FOOTER //
// ./src/services/CompanyBranches.js